module.exports = __webpack_public_path__ + "img/1106a_4.3b5b108d.jpg";